import IPPrintButton from './IPPrintButton'

export default IPPrintButton
